import { Button, InputOTP } from '@packages/ui/core';
import { ReactNode } from 'react';

type MfaVerificationFormProps = {
  description?: ReactNode;
  disabled?: boolean;
  error?: ReactNode;
  onCancel?: () => void;
  onSubmit: () => void;
  submitColor?: 'primary' | 'secondary' | 'danger' | 'success';
  submitLabel?: string;
  cancelLabel?: string;
  value: string;
  onChange: (value: string) => void;
};

const DEFAULT_LENGTH = 6;

export function MfaVerificationForm({
  description,
  disabled = false,
  error,
  onCancel,
  onSubmit,
  submitColor = 'primary',
  submitLabel = 'Verify',
  cancelLabel = 'Cancel',
  value,
  onChange,
}: MfaVerificationFormProps) {
  return (
    <div className="space-y-4">
      {description && <div className="text-sm text-gray-600">{description}</div>}

      <div className="flex justify-center">
        <InputOTP.Root autoFocus maxLength={DEFAULT_LENGTH} value={value} onChange={onChange}>
          <InputOTP.Group>
            {Array.from({ length: DEFAULT_LENGTH }).map((_, index) => (
              <InputOTP.Slot key={index} index={index} />
            ))}
          </InputOTP.Group>
        </InputOTP.Root>
      </div>

      {error && <div className="text-center text-sm text-red-600">{error}</div>}

      <div className="flex-col space-y-2">
        <Button color={submitColor} isFullWidth disabled={disabled || value.length !== DEFAULT_LENGTH} onClick={onSubmit}>
          {submitLabel}
        </Button>

        {onCancel && (
          <Button variant="outline" isFullWidth disabled={disabled} onClick={onCancel}>
            {cancelLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
